import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const useAllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [count, setCount] = useState(0);

  // Get authentication token
  const getHeaders = () => {
    const storedUser = localStorage.getItem('user');
    const token = storedUser ? JSON.parse(storedUser).token : null;
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  };

  // Fetch all users
  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get(
        `${base_url}api/auth/users`,
        getHeaders()
      );
      setUsers(data?.users || []);
      setCount(data?.count || 0);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch users');
      setUsers([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  // Update user role
  const updateUserRole = async (userId, email, roleId) => {
    setSaving(true);
    setError(null);
    try {
      const { data } = await axios.put(
        `${base_url}api/auth/update/${userId}`,
        { email, role: roleId },
        getHeaders()
      );
      const updatedUser = data?.user || data;
      setUsers((prev) =>
        prev.map((u) => (u._id === userId ? updatedUser : u))
      );
      setSaving(false);
      return updatedUser;
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to update user role');
      setSaving(false);
      return null;
    }
  };

  // Fetch users on mount
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return {
    users,
    loading,
    saving,
    error,
    count,
    fetchUsers,
    updateUserRole,
  };
};

export default useAllUsers;
